export const formatCredit = (credit?: number) => {
	return new Intl.NumberFormat('en', {
		// maximumFractionDigits: 0,
	}).format(credit || 0);
};
